import React from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';

import MultiChoiceQuestionForm from './MultiChoiceQuestionForm';
import { questionLayoutPropType } from '../../config/richTextConfig/questionLayout';
import TextQuestionRichText from '../../domains/richText/components/TextQuestionRichText';
import propTypeBlockStyling from '../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class MultiChoiceQuestion extends React.Component {
  static propTypes = {
    block: PropTypes.shape({
      clientUuid: PropTypes.string.isRequired,
      required: PropTypes.bool,
      content: PropTypes.object,
    }).isRequired,
    isCloned: PropTypes.bool,
    isInPreviewMode: PropTypes.bool,
    onAnswer: PropTypes.func.isRequired,
    layout: questionLayoutPropType,
    answer: PropTypes.shape({
      value: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          id: PropTypes.string,
        }),
      ),
      comments: PropTypes.string,
    }),
    styling: propTypeBlockStyling,
    questionNumber: PropTypes.number,
  };

  render = () => {
    const {
      block,
      block: { clientUuid, required, content },
      answer,
      layout,
      styling,
      questionNumber,
      isCloned,
      isInPreviewMode = false,
      onAnswer,
    } = this.props;

    const isConditionalQuestion = !!(block.logic && block.logic.message);

    return (
      <div>
        {isInPreviewMode &&
          isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
        <TextQuestionRichText
          questionNumber={questionNumber}
          layout={layout}
          content={content}
          required={required}
          styling={styling}
        />
        <MultiChoiceQuestionForm
          form={generateQuestionFormName(clientUuid, isCloned)}
          layout={layout}
          block={block}
          onSubmit={onAnswer}
          initialValues={answer}
          styling={styling}
        />
      </div>
    );
  };
}

export default MultiChoiceQuestion;
